import React from 'react';
import { useTranslation } from 'react-i18next';

import { Node } from '@uncinc/react-drupal-core';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import {
  SCREEN_MOBILE,
  SCREEN_TABLET,
  SCREEN_NORMAL,
  SCREEN_WIDE,
} from '../../../../config/constants';

import { CoreLink } from '../../../../components';

import './style.scss';

const ParagraphQuestionsOverviewItem = ({ entity }) => {
  const { t } = useTranslation();
  const questionTypeEntity = entity.getIn(['field_question_type', 0, 'entity']);
  const questionTypeName = questionTypeEntity.getIn(['name', 0, 'value']);
  const questionTypeLink = questionTypeEntity.getIn(['field_link', 0, 'alias'], questionTypeEntity.getIn(['field_link', 0, 'uri']));
  const questions = entity.getIn(['field_questions']);
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  const renderQuestionTypeImage = () => (
    <Image
      src={{
        [SCREEN_MOBILE]: entity.getIn(['field_question_type', 0, 'entity', 'field_image', 0, 'styles', 'ratio_16_9_sm']),
        [SCREEN_TABLET]: entity.getIn(['field_question_type', 0, 'entity', 'field_image', 0, 'styles', 'ratio_16_9_xs']),
        [SCREEN_NORMAL]: entity.getIn(['field_question_type', 0, 'entity', 'field_image', 0, 'styles', 'ratio_16_9_sm']),
        [SCREEN_WIDE]: entity.getIn(['field_question_type', 0, 'entity', 'field_image', 0, 'styles', 'ratio_16_9_md']),
      }}
      includeWebP
    />
  );

  return (
    <div id={paragraphKey} className="QuestionsOverviewItem__content">
      <div className="QuestionsOverviewItem__questions">
        {questionTypeName && (
          <h3 className="QuestionsOverviewItem__questionsTitle">{t('kp.questions_about') + ' ' + questionTypeName}</h3>
        )}
        {questions.map((question) => {
          const entity = question.getIn(['entity']);
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);

          return (
            <div key={`${uuid}:${langcode}`}>
              <Node
                id={id}
                key={`${uuid}:${langcode}`}
                isActivePath
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </div>
      <div className="QuestionsOverviewItem__image">
        {questionTypeLink ? (
          <CoreLink to={questionTypeLink}>
            {renderQuestionTypeImage()}
          </CoreLink>
        ) : (renderQuestionTypeImage())}
      </div>
    </div>
  );
};

export default ParagraphQuestionsOverviewItem;
